module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_007.png
// module id = 952
// module chunks = 0